// extracted by mini-css-extract-plugin
export default {"button":"PinkButton_button__iLSBW"};